import { createContext } from 'react';
export var PortalManagerContext = createContext(undefined);
export var PortalManagerProvider = PortalManagerContext.Provider;
